import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "리포지토리 구조화하기",
  "description": "생태계의 규칙을 사용하여 리포지토리를 생성하는 것부터 시작합니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "turbo는 JavaScript 생태계의 패키지 관리자 기능인 Workspaces 위에 구축되어 있으며, 이를 통해 하나의 리포지토리에 여러 패키지를 그룹화할 수 있습니다."
  }, {
    "heading": "",
    "content": "이러한 규칙을 따르는 것이 중요한 이유는 다음과 같습니다:"
  }, {
    "heading": "",
    "content": "리포지토리의 모든 도구에 대해 해당 규칙을 활용할 수 있습니다"
  }, {
    "heading": "",
    "content": "기존 리포지토리에 Turborepo를 빠르고 점진적으로 적용할 수 있습니다"
  }, {
    "heading": "",
    "content": "이 가이드에서는 turbo의 기반을 마련할 수 있도록 멀티 패키지 워크스페이스(모노레포) 설정 과정을 안내합니다."
  }, {
    "heading": "시작하기",
    "content": "워크스페이스 구조를 수동으로 설정하는 것은 번거로울 수 있습니다. 모노레포가 처음이라면 올바른 워크스페이스 구조로 바로 시작할 수 있도록 create-turbo 사용을 권장합니다."
  }, {
    "heading": "시작하기",
    "content": "그런 다음 이 가이드에 설명된 특성에 대해 리포지토리를 검토할 수 있습니다."
  }, {
    "heading": "워크스페이스의-구조",
    "content": "JavaScript에서 워크스페이스는 단일 패키지 또는 패키지 모음일 수 있습니다. 이 가이드에서는 종종 \"모노레포\"라고 불리는 멀티 패키지 워크스페이스에 초점을 맞춥니다."
  }, {
    "heading": "워크스페이스의-구조",
    "content": "아래는 유효한 워크스페이스로 만드는 create-turbo의 구조적 요소가 강조 표시되어 있습니다."
  }, {
    "heading": "최소-요구-사항",
    "content": "패키지 관리자가 설명하는 패키지"
  }, {
    "heading": "최소-요구-사항",
    "content": "패키지 관리자 lockfile"
  }, {
    "heading": "최소-요구-사항",
    "content": "루트 package.json"
  }, {
    "heading": "최소-요구-사항",
    "content": "루트 turbo.json"
  }, {
    "heading": "최소-요구-사항",
    "content": "각 패키지의 package.json"
  }, {
    "heading": "패키지-디렉토리-선언하기",
    "content": "먼저 패키지 관리자가 패키지의 위치를 설명해야 합니다. 애플리케이션과 서비스를 위한 apps/와 라이브러리 및 도구 등 그 외의 모든 것을 위한 packages/로 패키지를 나누는 것부터 시작하는 것을 권장합니다."
  }, {
    "heading": "패키지-디렉토리-선언하기",
    "content": "이 구성을 사용하면 apps 또는 packages 디렉토리에 package.json이 있는 모든 디렉토리가 패키지로 간주됩니다."
  }, {
    "heading": "패키지-디렉토리-선언하기",
    "content": "Turborepo는 JavaScript 생태계의 패키지 관리자 간에 모호한 동작으로 인해 apps/** 또는 packages/**와 같은 중첩된 패키지를 지원하지 않습니다. apps/a에 패키지를, apps/a/b에 다른 패키지를 배치하는 구조를 사용하면 오류가 발생합니다."
  }, {
    "heading": "패키지-디렉토리-선언하기",
    "content": "디렉토리별로 패키지를 그룹화하려면 packages/* 및 packages/group/*와 같은 glob을 사용하고 packages/group/package.json 파일을 생성하지 않으면 됩니다."
  }, {
    "heading": "각-패키지의-packagejson",
    "content": "패키지 디렉토리에는 패키지를 패키지 관리자와 turbo가 검색할 수 있도록 하는 package.json이 있어야 합니다. 패키지의 package.json 요구 사항은 아래에 있습니다."
  }, {
    "heading": "루트-packagejson",
    "content": "루트 package.json은 워크스페이스의 기반입니다. 아래는 루트 package.json에서 찾을 수 있는 일반적인 예입니다:"
  }, {
    "heading": "루트-turbojson",
    "content": "turbo.json은 turbo의 동작을 구성하는 데 사용됩니다. 작업 구성 방법에 대한 자세한 내용은 작업 구성 페이지를 참조하세요."
  }, {
    "heading": "패키지-관리자-lockfile",
    "content": "lockfile은 패키지 관리자와 turbo 모두에 대해 재현 가능한 동작의 핵심입니다. 또한 Turborepo는 lockfile을 사용하여 워크스페이스 내 내부 패키지 간의 의존성을 이해합니다."
  }, {
    "heading": "패키지-관리자-lockfile",
    "content": "turbo를 실행할 때 lockfile이 없으면 예측할 수 없는 동작이 나타날 수\n있습니다."
  }, {
    "heading": "패키지의-구조",
    "content": "워크스페이스 내에서 각 패키지를 고유한 단위로 설계하는 것부터 시작하는 것이 가장 좋습니다. 높은 수준에서 각 패키지는 자체 package.json, 도구 구성 및 소스 코드가 있는 자체 작은 \"프로젝트\"와 거의 같습니다. 이 아이디어에는 한계가 있지만 시작하기에 좋은 정신적 모델입니다."
  }, {
    "heading": "패키지의-구조",
    "content": "또한 패키지에는 워크스페이스의 다른 패키지가 exports로 지정된 패키지에 액세스하는 데 사용할 수 있는 특정 진입점이 있습니다."
  }, {
    "heading": "name",
    "content": "name 필드는 패키지를 식별하는 데 사용됩니다. 워크스페이스 내에서 고유해야 합니다."
  }, {
    "heading": "name",
    "content": "npm 레지스트리의 다른 패키지와의 충돌을 피하기 위해 내부 패키지에 네임스페이스 접두사를 사용하는 것이 좋습니다. 예를 들어 조직 이름이 acme인 경우 패키지 이름을 @acme/package-name으로 지정할 수 있습니다."
  }, {
    "heading": "name",
    "content": "문서와 예제에서는 npm 레지스트리에서 사용되지 않고 클레임할 수 없는 네임스페이스이기 때문에 @repo를 사용합니다. 그대로 유지하거나 자체 접두사를 사용할 수 있습니다."
  }, {
    "heading": "scripts",
    "content": "scripts 필드는 패키지의 컨텍스트에서 실행할 수 있는 스크립트를 정의하는 데 사용됩니다. Turborepo는 이러한 스크립트의 이름을 사용하여 패키지에서 실행할 스크립트(있는 경우)를 식별합니다. 이러한 스크립트에 대한 자세한 내용은 작업 실행 페이지에서 설명합니다."
  }, {
    "heading": "exports",
    "content": "exports 필드는 패키지를 사용하려는 다른 패키지의 진입점을 지정하는 데 사용됩니다. 한 패키지에서 다른 패키지의 코드를 사용하려는 경우 해당 진입점에서 가져옵니다."
  }, {
    "heading": "exports",
    "content": "예를 들어 @repo/math 패키지가 있는 경우 다음과 같은 exports 필드를 가질 수 있습니다:"
  }, {
    "heading": "exports",
    "content": "이 예제는 단순화를 위해 Just-in-Time 패키지 패턴을 사용합니다. TypeScript를 직접 내보내지만 대신 컴파일된 패키지 패턴을 선택할 수도 있습니다."
  }, {
    "heading": "exports",
    "content": "이 예제의 exports 필드는 최신 버전의 Node.js 및 TypeScript가 필요합니다."
  }, {
    "heading": "exports",
    "content": "이를 통해 다음과 같이 @repo/math 패키지에서 add 및 subtract 함수를 가져올 수 있습니다:"
  }, {
    "heading": "exports",
    "content": "이러한 방식으로 exports를 사용하면 세 가지 주요 이점이 있습니다:"
  }, {
    "heading": "exports",
    "content": "배럴 파일 피하기: 배럴 파일은 동일한 패키지의 다른 파일을 다시 내보내어 전체 패키지에 대한 하나의 진입점을 생성하는 파일입니다. 편리해 보일 수 있지만 컴파일러와 번들러가 처리하기 어렵고 빠르게 성능 문제로 이어질 수 있습니다."
  }, {
    "heading": "exports",
    "content": "더 강력한 기능: exports는 조건부 Exports와 같은 main 필드에 비해 다른 강력한 기능도 있습니다. 일반적으로 가능한 한 main 대신 exports를 사용하는 것이 좋습니다. 이는 더 현대적인 옵션이기 때문입니다."
  }, {
    "heading": "exports",
    "content": "IDE 자동 완성: exports를 사용하여 패키지의 진입점을 지정하면 코드 편집기가 패키지의 exports에 대한 자동 완성을 제공할 수 있습니다."
  }, {
    "heading": "imports-선택-사항",
    "content": "imports 필드는 패키지 내의 다른 모듈에 대한 하위 경로를 만드는 방법을 제공합니다. 파일을 이동하는 리팩토링에 더 탄력적인 간단한 가져오기 경로를 작성하는 \"바로 가기\"와 같다고 생각할 수 있습니다. 방법을 알아보려면 TypeScript 페이지를 참조하세요."
  }, {
    "heading": "imports-선택-사항",
    "content": "유사한 목표를 달성하는 TypeScript의 compilerOptions#paths 옵션에 더 익숙할 수 있습니다. TypeScript 5.4부터 TypeScript는 imports에서 하위 경로를 추론할 수 있으므로 Node.js 규칙과 함께 작업하게 되므로 더 나은 옵션입니다. 자세한 내용은 TypeScript 가이드를 참조하세요."
  }, {
    "heading": "소스-코드",
    "content": "물론 패키지에 일부 소스 코드가 필요합니다. 패키지는 일반적으로 src 디렉토리를 사용하여 소스 코드를 저장하고 dist 디렉토리(패키지 내에도 위치해야 함)로 컴파일하지만 이는 요구 사항이 아닙니다."
  }, {
    "heading": "일반적인-함정",
    "content": "TypeScript를 사용하는 경우 워크스페이스의 루트에 tsconfig.json이 필요하지 않을 수 있습니다. 패키지는 일반적으로 워크스페이스의 별도 패키지에서 공유 tsconfig.json을 기반으로 자체 구성을 독립적으로 지정해야 합니다. 자세한 내용은 TypeScript 가이드를 참조하세요."
  }, {
    "heading": "일반적인-함정",
    "content": "가능한 한 패키지 경계를 넘어 파일에 액세스하는 것을 피해야 합니다. 한 패키지에서 다른 패키지로 이동하기 위해 ../를 작성하는 경우 필요한 곳에 패키지를 설치하고 코드로 가져와서 접근 방식을 다시 생각할 기회가 있을 수 있습니다."
  }, {
    "heading": "다음-단계",
    "content": "워크스페이스가 구성되었으므로 이제 패키지 관리자를 사용하여 패키지에 의존성을 설치할 수 있습니다."
  }],
  "headings": [{
    "id": "시작하기",
    "content": "시작하기"
  }, {
    "id": "워크스페이스의-구조",
    "content": "워크스페이스의 구조"
  }, {
    "id": "최소-요구-사항",
    "content": "최소 요구 사항"
  }, {
    "id": "모노레포에서-패키지-지정하기",
    "content": "모노레포에서 패키지 지정하기"
  }, {
    "id": "패키지-디렉토리-선언하기",
    "content": "패키지 디렉토리 선언하기"
  }, {
    "id": "각-패키지의-packagejson",
    "content": "각 패키지의 package.json"
  }, {
    "id": "루트-packagejson",
    "content": "루트 package.json"
  }, {
    "id": "루트-turbojson",
    "content": "루트 turbo.json"
  }, {
    "id": "패키지-관리자-lockfile",
    "content": "패키지 관리자 lockfile"
  }, {
    "id": "패키지의-구조",
    "content": "패키지의 구조"
  }, {
    "id": "패키지의-packagejson",
    "content": "패키지의 package.json"
  }, {
    "id": "name",
    "content": "name"
  }, {
    "id": "scripts",
    "content": "scripts"
  }, {
    "id": "exports",
    "content": "exports"
  }, {
    "id": "imports-선택-사항",
    "content": "imports (선택 사항)"
  }, {
    "id": "소스-코드",
    "content": "소스 코드"
  }, {
    "id": "일반적인-함정",
    "content": "일반적인 함정"
  }, {
    "id": "다음-단계",
    "content": "다음 단계"
  }]
};
import {Callout} from '#components/callout';
import {PackageManagerTabs, Tab, Tabs} from '#components/tabs';
import {Step, Steps} from '#components/steps';
import {File, Folder, Files} from '#components/files';
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#시작하기",
  title: _jsx(_Fragment, {
    children: "시작하기"
  })
}, {
  depth: 2,
  url: "#워크스페이스의-구조",
  title: _jsx(_Fragment, {
    children: "워크스페이스의 구조"
  })
}, {
  depth: 3,
  url: "#최소-요구-사항",
  title: _jsx(_Fragment, {
    children: "최소 요구 사항"
  })
}, {
  depth: 3,
  url: "#모노레포에서-패키지-지정하기",
  title: _jsx(_Fragment, {
    children: "모노레포에서 패키지 지정하기"
  })
}, {
  depth: 4,
  url: "#패키지-디렉토리-선언하기",
  title: _jsx(_Fragment, {
    children: "패키지 디렉토리 선언하기"
  })
}, {
  depth: 4,
  url: "#각-패키지의-packagejson",
  title: _jsxs(_Fragment, {
    children: ["각 패키지의 ", _jsx("code", {
      children: "package.json"
    })]
  })
}, {
  depth: 3,
  url: "#루트-packagejson",
  title: _jsxs(_Fragment, {
    children: ["루트 ", _jsx("code", {
      children: "package.json"
    })]
  })
}, {
  depth: 3,
  url: "#루트-turbojson",
  title: _jsxs(_Fragment, {
    children: ["루트 ", _jsx("code", {
      children: "turbo.json"
    })]
  })
}, {
  depth: 3,
  url: "#패키지-관리자-lockfile",
  title: _jsx(_Fragment, {
    children: "패키지 관리자 lockfile"
  })
}, {
  depth: 2,
  url: "#패키지의-구조",
  title: _jsx(_Fragment, {
    children: "패키지의 구조"
  })
}, {
  depth: 3,
  url: "#패키지의-packagejson",
  title: _jsxs(_Fragment, {
    children: ["패키지의 ", _jsx("code", {
      children: "package.json"
    })]
  })
}, {
  depth: 4,
  url: "#name",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "name"
    })
  })
}, {
  depth: 4,
  url: "#scripts",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "scripts"
    })
  })
}, {
  depth: 4,
  url: "#exports",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "exports"
    })
  })
}, {
  depth: 4,
  url: "#imports-선택-사항",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "imports"
    }), " (선택 사항)"]
  })
}, {
  depth: 3,
  url: "#소스-코드",
  title: _jsx(_Fragment, {
    children: "소스 코드"
  })
}, {
  depth: 2,
  url: "#일반적인-함정",
  title: _jsx(_Fragment, {
    children: "일반적인 함정"
  })
}, {
  depth: 2,
  url: "#다음-단계",
  title: _jsx(_Fragment, {
    children: "다음 단계"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "는 JavaScript 생태계의 패키지 관리자 기능인 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#workspace",
        children: "Workspaces"
      }), " 위에 구축되어 있으며, 이를 통해 하나의 리포지토리에 여러 패키지를 그룹화할 수 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "이러한 규칙을 따르는 것이 중요한 이유는 다음과 같습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "리포지토리의 모든 도구에 대해 해당 규칙을 활용할 수 있습니다"
      }), "\n", _jsx(_components.li, {
        children: "기존 리포지토리에 Turborepo를 빠르고 점진적으로 적용할 수 있습니다"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["이 가이드에서는 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 기반을 마련할 수 있도록 멀티 패키지 워크스페이스(모노레포) 설정 과정을 안내합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "시작하기",
      children: "시작하기"
    }), "\n", _jsxs(_components.p, {
      children: ["워크스페이스 구조를 수동으로 설정하는 것은 번거로울 수 있습니다. 모노레포가 처음이라면 ", _jsxs(_components.a, {
        href: "/docs/getting-started/installation",
        children: ["올바른 워크스페이스 구조로 바로 시작할 수 있도록 ", _jsx(_components.code, {
          children: "create-turbo"
        }), " 사용"]
      }), "을 권장합니다."]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "그런 다음 이 가이드에 설명된 특성에 대해 리포지토리를 검토할 수 있습니다."
    }), "\n", _jsx(_components.h2, {
      id: "워크스페이스의-구조",
      children: "워크스페이스의 구조"
    }), "\n", _jsxs(_components.p, {
      children: ["JavaScript에서 워크스페이스는 ", _jsx(_components.a, {
        href: "/docs/guides/single-package-workspaces",
        children: "단일 패키지"
      }), " 또는 패키지 모음일 수 있습니다. 이 가이드에서는 종종 \"모노레포\"라고 불리는 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/vercel-platform/glossary#monorepo",
        children: "멀티 패키지 워크스페이스"
      }), "에 초점을 맞춥니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["아래는 유효한 워크스페이스로 만드는 ", _jsx(_components.code, {
        children: "create-turbo"
      }), "의 구조적 요소가 강조 표시되어 있습니다."]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsxs(Files, {
          children: [_jsx(File, {
            name: "package.json",
            green: true
          }), _jsx(File, {
            name: "pnpm-lock.yaml",
            green: true
          }), _jsx(File, {
            name: "pnpm-workspace.yaml",
            green: true
          }), _jsx(File, {
            name: "turbo.json"
          }), _jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              className: "text-foreground",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            }), _jsx(Folder, {
              name: "web",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })]
          }), _jsx(Folder, {
            name: "packages",
            children: _jsx(Folder, {
              name: "ui",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })
          })]
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsxs(Files, {
          children: [_jsx(File, {
            name: "package.json",
            green: true
          }), _jsx(File, {
            name: "yarn.lock",
            green: true
          }), _jsx(File, {
            name: "turbo.json"
          }), _jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              className: "text-foreground",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            }), _jsx(Folder, {
              name: "web",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })]
          }), _jsx(Folder, {
            name: "packages",
            children: _jsx(Folder, {
              name: "ui",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })
          })]
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsxs(Files, {
          children: [_jsx(File, {
            name: "package.json",
            green: true
          }), _jsx(File, {
            name: "package-lock.json",
            green: true
          }), _jsx(File, {
            name: "turbo.json"
          }), _jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              className: "text-foreground",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            }), _jsx(Folder, {
              name: "web",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })]
          }), _jsx(Folder, {
            name: "packages",
            children: _jsx(Folder, {
              name: "ui",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })
          })]
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsxs(Files, {
          children: [_jsx(File, {
            name: "package.json",
            green: true
          }), _jsx(File, {
            name: "bun.lock",
            green: true
          }), _jsx(File, {
            name: "turbo.json"
          }), _jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              className: "text-foreground",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            }), _jsx(Folder, {
              name: "web",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })]
          }), _jsx(Folder, {
            name: "packages",
            children: _jsx(Folder, {
              name: "ui",
              children: _jsx(File, {
                name: "package.json",
                green: true
              })
            })
          })]
        })
      })]
    }), "\n", _jsx(_components.h3, {
      id: "최소-요구-사항",
      children: "최소 요구 사항"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#specifying-packages-in-a-monorepo",
          children: "패키지 관리자가 설명하는 패키지"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#package-manager-lockfile",
          children: "패키지 관리자 lockfile"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "#root-packagejson",
          children: ["루트 ", _jsx(_components.code, {
            children: "package.json"
          })]
        })
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "#root-turbojson",
          children: ["루트 ", _jsx(_components.code, {
            children: "turbo.json"
          })]
        })
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "#packagejson-in-each-package",
          children: ["각 패키지의 ", _jsx(_components.code, {
            children: "package.json"
          })]
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "모노레포에서-패키지-지정하기",
      children: "모노레포에서 패키지 지정하기"
    }), "\n", _jsxs(Steps, {
      children: [_jsxs(Step, {
        children: [_jsx(_components.h4, {
          id: "패키지-디렉토리-선언하기",
          children: "패키지 디렉토리 선언하기"
        }), _jsxs(_components.p, {
          children: ["먼저 패키지 관리자가 패키지의 위치를 설명해야 합니다. 애플리케이션과 서비스를 위한 ", _jsx(_components.code, {
            children: "apps/"
          }), "와 라이브러리 및 도구 등 그 외의 모든 것을 위한 ", _jsx(_components.code, {
            children: "packages/"
          }), "로 패키지를 나누는 것부터 시작하는 것을 권장합니다."]
        }), _jsxs(PackageManagerTabs, {
          children: [_jsxs(Tab, {
            value: "pnpm",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "pnpm-workspace.yaml",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "packages:"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  - "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"apps/*\""
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  - "
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "\"packages/*\""
                    })]
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://pnpm.io/pnpm-workspace_yaml",
              children: "pnpm 워크스페이스 문서"
            })]
          }), _jsxs(Tab, {
            value: "yarn",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://yarnpkg.com/features/workspaces#how-are-workspaces-declared",
              children: "yarn 워크스페이스 문서"
            })]
          }), _jsxs(Tab, {
            value: "npm",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://docs.npmjs.com/cli/v7/using-npm/workspaces#defining-workspaces",
              children: "npm 워크스페이스 문서"
            })]
          }), _jsxs(Tab, {
            value: "bun (Beta)",
            children: [_jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-keyword)",
                        "--shiki-dark": "var(--shiki-token-keyword)"
                      },
                      children: "  \"workspaces\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ":"
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: " ["
                    })]
                  }), "\n", _jsxs(_components.span, {
                    className: "line",
                    children: [_jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"apps/*\""
                    }), _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-punctuation)",
                        "--shiki-dark": "var(--shiki-token-punctuation)"
                      },
                      children: ","
                    })]
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-string-expression)",
                        "--shiki-dark": "var(--shiki-token-string-expression)"
                      },
                      children: "    \"packages/*\""
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  ]"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            }), _jsx(LinkToDocumentation, {
              href: "https://bun.sh/docs/install/workspaces",
              children: "bun 워크스페이스 문서"
            })]
          })]
        }), _jsxs(_components.p, {
          children: ["이 구성을 사용하면 ", _jsx(_components.code, {
            children: "apps"
          }), " 또는 ", _jsx(_components.code, {
            children: "packages"
          }), " 디렉토리에 ", _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "package.json"
            }), "이 있는"]
          }), " 모든 디렉토리가 패키지로 간주됩니다."]
        }), _jsxs(Callout, {
          type: "error",
          children: [_jsxs(_components.p, {
            children: ["Turborepo는 JavaScript 생태계의 패키지 관리자 간에 모호한 동작으로 인해 ", _jsx(_components.code, {
              children: "apps/**"
            }), " 또는 ", _jsx(_components.code, {
              children: "packages/**"
            }), "와 같은 중첩된 패키지를 지원하지 않습니다. ", _jsx(_components.code, {
              children: "apps/a"
            }), "에 패키지를, ", _jsx(_components.code, {
              children: "apps/a/b"
            }), "에 다른 패키지를 배치하는 구조를 사용하면 오류가 발생합니다."]
          }), _jsxs(_components.p, {
            children: ["디렉토리별로 패키지를 그룹화하려면 ", _jsx(_components.code, {
              children: "packages/*"
            }), " 및 ", _jsx(_components.code, {
              children: "packages/group/*"
            }), "와 같은 glob을 사용하고 ", _jsx(_components.code, {
              children: "packages/group/package.json"
            }), " 파일을 생성하지 ", _jsx(_components.strong, {
              children: "않으면"
            }), " 됩니다."]
          })]
        })]
      }), _jsxs(Step, {
        children: [_jsxs(_components.h4, {
          id: "각-패키지의-packagejson",
          children: ["각 패키지의 ", _jsx(_components.code, {
            children: "package.json"
          })]
        }), _jsxs(_components.p, {
          children: ["패키지 디렉토리에는 패키지를 패키지 관리자와 ", _jsx(_components.code, {
            children: "turbo"
          }), "가 검색할 수 있도록 하는 ", _jsx(_components.code, {
            children: "package.json"
          }), "이 있어야 합니다. ", _jsxs(_components.a, {
            href: "#anatomy-of-a-package",
            children: ["패키지의 ", _jsx(_components.code, {
              children: "package.json"
            }), " 요구 사항"]
          }), "은 아래에 있습니다."]
        })]
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "루트-packagejson",
      children: ["루트 ", _jsx(_components.code, {
        children: "package.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["루트 ", _jsx(_components.code, {
        children: "package.json"
      }), "은 워크스페이스의 기반입니다. 아래는 루트 ", _jsx(_components.code, {
        children: "package.json"
      }), "에서 찾을 수 있는 일반적인 예입니다:"]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"private\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"turbo\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"pnpm@9.0.0\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"private\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"turbo\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"yarn@1.22.19\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"workspaces\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"apps/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"packages/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"private\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"turbo\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"npm@10.0.0\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"workspaces\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"apps/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"packages/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"private\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: " true"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"scripts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"lint\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"turbo run lint\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"turbo\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"packageManager\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"bun@1.2.0\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"workspaces\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"apps/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"packages/*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "루트-turbojson",
      children: ["루트 ", _jsx(_components.code, {
        children: "turbo.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), "은 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 동작을 구성하는 데 사용됩니다. 작업 구성 방법에 대한 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        children: "작업 구성"
      }), " 페이지를 참조하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "패키지-관리자-lockfile",
      children: "패키지 관리자 lockfile"
    }), "\n", _jsxs(_components.p, {
      children: ["lockfile은 패키지 관리자와 ", _jsx(_components.code, {
        children: "turbo"
      }), " 모두에 대해 재현 가능한 동작의 핵심입니다. 또한 Turborepo는 lockfile을 사용하여 워크스페이스 내 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "내부 패키지"
      }), " 간의 의존성을 이해합니다."]
    }), "\n", _jsx(Callout, {
      type: "warn",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo"
        }), "를 실행할 때 lockfile이 없으면 예측할 수 없는 동작이 나타날 수\n있습니다."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "패키지의-구조",
      children: "패키지의 구조"
    }), "\n", _jsxs(_components.p, {
      children: ["워크스페이스 내에서 각 패키지를 고유한 단위로 설계하는 것부터 시작하는 것이 가장 좋습니다. 높은 수준에서 각 패키지는 자체 ", _jsx(_components.code, {
        children: "package.json"
      }), ", 도구 구성 및 소스 코드가 있는 자체 작은 \"프로젝트\"와 거의 같습니다. 이 아이디어에는 한계가 있지만 ", _jsx(_components.em, {
        children: "시작"
      }), "하기에 좋은 정신적 모델입니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["또한 패키지에는 워크스페이스의 다른 패키지가 ", _jsx(_components.a, {
        href: "#exports",
        children: _jsx(_components.code, {
          children: "exports"
        })
      }), "로 지정된 패키지에 액세스하는 데 사용할 수 있는 특정 진입점이 있습니다."]
    }), "\n", _jsxs(_components.h3, {
      id: "패키지의-packagejson",
      children: ["패키지의 ", _jsx(_components.code, {
        children: "package.json"
      })]
    }), "\n", _jsx(_components.h4, {
      id: "name",
      children: _jsx(_components.code, {
        children: "name"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://nodejs.org/api/packages.html#name",
        children: [_jsx(_components.code, {
          children: "name"
        }), " 필드"]
      }), "는 패키지를 식별하는 데 사용됩니다. 워크스페이스 내에서 고유해야 합니다."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["npm 레지스트리의 다른 패키지와의 충돌을 피하기 위해 ", _jsx(_components.a, {
          href: "/docs/core-concepts/internal-packages",
          children: "내부 패키지"
        }), "에 네임스페이스 접두사를 사용하는 것이 좋습니다. 예를 들어 조직 이름이 ", _jsx(_components.code, {
          children: "acme"
        }), "인 경우 패키지 이름을 ", _jsx(_components.code, {
          children: "@acme/package-name"
        }), "으로 지정할 수 있습니다."]
      }), _jsxs(_components.p, {
        children: ["문서와 예제에서는 npm 레지스트리에서 사용되지 않고 클레임할 수 없는 네임스페이스이기 때문에 ", _jsx(_components.code, {
          children: "@repo"
        }), "를 사용합니다. 그대로 유지하거나 자체 접두사를 사용할 수 있습니다."]
      })]
    }), "\n", _jsx(_components.h4, {
      id: "scripts",
      children: _jsx(_components.code, {
        children: "scripts"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "scripts"
      }), " 필드는 패키지의 컨텍스트에서 실행할 수 있는 스크립트를 정의하는 데 사용됩니다. Turborepo는 이러한 스크립트의 이름을 사용하여 패키지에서 실행할 스크립트(있는 경우)를 식별합니다. 이러한 스크립트에 대한 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "작업 실행"
      }), " 페이지에서 설명합니다."]
    }), "\n", _jsx(_components.h4, {
      id: "exports",
      children: _jsx(_components.code, {
        children: "exports"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://nodejs.org/api/packages.html#exports",
        children: [_jsx(_components.code, {
          children: "exports"
        }), " 필드"]
      }), "는 패키지를 사용하려는 다른 패키지의 진입점을 지정하는 데 사용됩니다. 한 패키지에서 다른 패키지의 코드를 사용하려는 경우 해당 진입점에서 가져옵니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["예를 들어 ", _jsx(_components.code, {
        children: "@repo/math"
      }), " 패키지가 있는 경우 다음과 같은 ", _jsx(_components.code, {
        children: "exports"
      }), " 필드를 가질 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/math/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"exports\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \".\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/constants.ts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./add\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/add.ts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./subtract\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/subtract.ts\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 예제는 단순화를 위해 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#just-in-time-packages",
        children: "Just-in-Time 패키지"
      }), " 패턴을 사용합니다. TypeScript를 직접 내보내지만 대신 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#compiled-packages",
        children: "컴파일된 패키지"
      }), " 패턴을 선택할 수도 있습니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["이 예제의 ", _jsx(_components.code, {
          children: "exports"
        }), " 필드는 최신 버전의 Node.js 및 TypeScript가 필요합니다."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이를 통해 다음과 같이 ", _jsx(_components.code, {
        children: "@repo/math"
      }), " 패키지에서 ", _jsx(_components.code, {
        children: "add"
      }), " 및 ", _jsx(_components.code, {
        children: "subtract"
      }), " 함수를 가져올 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/my-app/src/index.ts",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { GRAVITATIONAL_CONSTANT"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " SPEED_OF_LIGHT } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/math'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { add } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/math/add'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { subtract } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/math/subtract'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이러한 방식으로 exports를 사용하면 세 가지 주요 이점이 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "배럴 파일 피하기"
        }), ": 배럴 파일은 동일한 패키지의 다른 파일을 다시 내보내어 전체 패키지에 대한 하나의 진입점을 생성하는 파일입니다. 편리해 보일 수 있지만 ", _jsx(_components.a, {
          href: "https://vercel.com/blog/how-we-optimized-package-imports-in-next-js#what's-the-problem-with-barrel-files",
          children: "컴파일러와 번들러가 처리하기 어렵고"
        }), " 빠르게 성능 문제로 이어질 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "더 강력한 기능"
        }), ": ", _jsx(_components.code, {
          children: "exports"
        }), "는 ", _jsx(_components.a, {
          href: "https://nodejs.org/api/packages.html#conditional-exports",
          children: "조건부 Exports"
        }), "와 같은 ", _jsxs(_components.a, {
          href: "https://nodejs.org/api/packages.html#main",
          children: [_jsx(_components.code, {
            children: "main"
          }), " 필드"]
        }), "에 비해 다른 강력한 기능도 있습니다. 일반적으로 가능한 한 ", _jsx(_components.code, {
          children: "main"
        }), " 대신 ", _jsx(_components.code, {
          children: "exports"
        }), "를 사용하는 것이 좋습니다. 이는 더 현대적인 옵션이기 때문입니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "IDE 자동 완성"
        }), ": ", _jsx(_components.code, {
          children: "exports"
        }), "를 사용하여 패키지의 진입점을 지정하면 코드 편집기가 패키지의 exports에 대한 자동 완성을 제공할 수 있습니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.h4, {
      id: "imports-선택-사항",
      children: [_jsx(_components.code, {
        children: "imports"
      }), " (선택 사항)"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://nodejs.org/api/packages.html#imports",
        children: [_jsx(_components.code, {
          children: "imports"
        }), " 필드"]
      }), "는 패키지 내의 다른 모듈에 대한 하위 경로를 만드는 방법을 제공합니다. 파일을 이동하는 리팩토링에 더 탄력적인 간단한 가져오기 경로를 작성하는 \"바로 가기\"와 같다고 생각할 수 있습니다. 방법을 알아보려면 ", _jsx(_components.a, {
        href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
        children: "TypeScript 페이지"
      }), "를 참조하세요."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["유사한 목표를 달성하는 TypeScript의 ", _jsx(_components.code, {
          children: "compilerOptions#paths"
        }), " 옵션에 더 익숙할 수 있습니다. TypeScript 5.4부터 TypeScript는 ", _jsx(_components.code, {
          children: "imports"
        }), "에서 하위 경로를 추론할 수 있으므로 Node.js 규칙과 함께 작업하게 되므로 더 나은 옵션입니다. 자세한 내용은 ", _jsx(_components.a, {
          href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
          children: "TypeScript 가이드"
        }), "를 참조하세요."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "소스-코드",
      children: "소스 코드"
    }), "\n", _jsxs(_components.p, {
      children: ["물론 패키지에 일부 소스 코드가 필요합니다. 패키지는 일반적으로 ", _jsx(_components.code, {
        children: "src"
      }), " 디렉토리를 사용하여 소스 코드를 저장하고 ", _jsx(_components.code, {
        children: "dist"
      }), " 디렉토리(패키지 내에도 위치해야 함)로 컴파일하지만 이는 요구 사항이 아닙니다."]
    }), "\n", _jsx(_components.h2, {
      id: "일반적인-함정",
      children: "일반적인 함정"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["TypeScript를 사용하는 경우 워크스페이스의 루트에 ", _jsx(_components.code, {
          children: "tsconfig.json"
        }), "이 필요하지 않을 수 있습니다. 패키지는 일반적으로 워크스페이스의 별도 패키지에서 공유 ", _jsx(_components.code, {
          children: "tsconfig.json"
        }), "을 기반으로 자체 구성을 독립적으로 지정해야 합니다. 자세한 내용은 ", _jsx(_components.a, {
          href: "/docs/guides/tools/typescript#you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
          children: "TypeScript 가이드"
        }), "를 참조하세요."]
      }), "\n", _jsxs(_components.li, {
        children: ["가능한 한 패키지 경계를 넘어 파일에 액세스하는 것을 피해야 합니다. 한 패키지에서 다른 패키지로 이동하기 위해 ", _jsx(_components.code, {
          children: "../"
        }), "를 작성하는 경우 필요한 곳에 패키지를 설치하고 코드로 가져와서 접근 방식을 다시 생각할 기회가 있을 수 있습니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "다음-단계",
      children: "다음 단계"
    }), "\n", _jsxs(_components.p, {
      children: ["워크스페이스가 구성되었으므로 이제 패키지 관리자를 사용하여 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/managing-dependencies",
        children: "패키지에 의존성을 설치"
      }), "할 수 있습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
